/**
 * @fileoverview GET handler for the "/engagement/predictions_data" endpoint
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionsData } from "./constants";
import type { EngagementPredictionsDataParams, EngagementPredictionsDataResult } from "./types";

export const getDataTableEngagementPredictionsData = reactQueryTableFetcherAdapter(
  engagementPredictionsData,
  (
    signal: AbortSignal,
    { query, limit = 20, start = 0, sortby = "name", sortdir = 1 }: EngagementPredictionsDataParams
  ): Promise<EngagementPredictionsDataResult> => {
    return fetch(
      engagementPredictionsData,
      "GET",
      {
        limit,
        start,
        sortby,
        sortdir,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  }
);
